import { Slide, ToastContainer } from 'react-toastify';
import { RouterProvider } from 'react-router-dom';
import AppRouter from 'components/Router';
import { AppLoadingOverlay } from 'components/UI/AppLoadingOverlay';
import { useAppSelector } from 'store/hooks';
import { ProductType } from 'views/types';
import { useDirection } from 'hooks/useDirection';

interface MainAppProps {
  pageMode?: boolean;
  productType: ProductType;
  isLocalizationLoading: boolean;
}

const MainApp = ({ pageMode, productType, isLocalizationLoading }: MainAppProps) => {
  const productTypeResolved = useAppSelector((state) => state.global.productTypeResolved);
  const { direction, isRtl } = useDirection();

  return (
    <div
        className={`app-container ${pageMode ? 'page-mode' : ''} product-${productType.toLowerCase()}`}
        dir={direction}
    >
      {(!productTypeResolved || isLocalizationLoading) && <AppLoadingOverlay />}
      <ToastContainer
        transition={Slide}
        hideProgressBar
        autoClose={7000}
        position={isRtl ? 'top-left' : 'top-right'}
        rtl={isRtl}
      />
      <RouterProvider router={AppRouter} />
    </div>
  );
};

export default MainApp;
